import { env } from './environment';

export const appConfig = {
  app: {
    name: 'WCI',
    displayName: 'Wealthcraft Innovations',
    env: env.APP_ENV,
    isLocal: env.APP_ENV === 'local',
    isDevelopment: env.APP_ENV === 'development',
    isQA: env.APP_ENV === 'qa',
    isProduction: env.APP_ENV === 'production',
  },

  urls: {
    app: env.APP_URL,
    site: env.SITE_URL,
    apiBase: env.API_BASE_URL,
    assetsBase: env.ASSETS_BASE_URL,
  },

  integrations: {
    calendly: {
      eventUrl: env.CALENDLY_EVENT_URL,
      enabled: Boolean(env.CALENDLY_EVENT_URL),
    },
    vercelMetrics: {
      enabled: env.ENABLE_VERCEL_METRICS,
    },
  },

  defaults: {
    locale: 'en',
    timezone: 'Asia/Kolkata',
  },
} as const;
